import { Stack } from "@mui/material";
import type { FC } from "react";
import type { FilterSectionProps } from "web_myplann/NotificationCenter/Types/FilterSectionProps";
import { SectionHeader } from "web_myplann/Shared/Components/SectionHeader";

export const FilterSectionV2: FC<FilterSectionProps> = ({
	title,
	testIdPrefix,
	children,
}) => (
	<Stack data-testid={`notification-center-filter-section-${testIdPrefix}`}>
		<SectionHeader title={title} />
		<Stack role="radiogroup" aria-label={title} bgcolor="background.paper">
			{children}
		</Stack>
	</Stack>
);
